export default __webpack_public_path__ + "static/media/hero-text-right.6efa88ae.png";